import { Container } from '@mui/material';
import React from 'react'
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';

const LockerMenu = (props) => {
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
        {
        title: "ABOUT",
        link: "#about",
        },
        {
        title: "TOKENOMICS",
        link: "#tokenomics",
        },
        {
        title: "HOW TO BUY",
        link: "#how to buy",
        },
        // {
        // title: "WHITEPAPER",
        // link: "",
        // target:"blank"
        // },
        {
        title: "MEMES",
        link: "#memes",
        },
        {
        title: "TELEGRAM",
        link: "https://t.me/obamapredator_erc20",
        target:"blank"
        },
        {
        title: "TWITTER",
        link: "https://twitter.com/obamapredator",
        target:"blank"
        },
    ];
  return (
    <Container>
        <DesktopMenu menuList={menuList} />
        <MobileMenu menuList={menuList} />
    </Container>
  )
}

export default LockerMenu